import { ColDef } from "ag-grid-community";

import {
    CreatedAtCellRenderer,
    Info,
    OrganizationCountCellRenderer,
    RolesCellRenderer,
    StatusCellRenderer,
} from "./GridFrameworks";

const columnDef: ColDef[] = [
    {
        headerName: "",
        field: "Id",
        cellRenderer: Info,
        width: 65,
        minWidth: 65,
        pinned: "left",
    },
    {
        headerName: "First Name",
        field: "FirstName",
        sortable: true,
        filter: true,
        resizable: true,
        headerStyle: { paddingLeft: "8px" },
        cellStyle: { paddingLeft: "8px" },
    },
    {
        headerName: "Last Name",
        field: "LastName",
        sortable: true,
        resizable: true,
    },
    {
        headerName: "Email",
        field: "Email",
        sortable: true,
        resizable: true,
        flex: 1,
        minWidth: 200,
    },
    {
        headerName: "Organizations",
        field: "OrganizationCount",
        cellRenderer: OrganizationCountCellRenderer,
        sortable: true,
        width: 140,
    },
    {
        headerName: "Roles",
        field: "RoleNames",
        cellRenderer: RolesCellRenderer,
        sortable: true,
        filter: true,
        resizable: true,
        minWidth: 140,
    },
    {
        headerName: "Status",
        field: "IsActive",
        cellRenderer: StatusCellRenderer,
        sortable: true,
        width: 120,
    },
    {
        headerName: "Created At",
        field: "CreatedAt",
        cellRenderer: CreatedAtCellRenderer,
        sortable: true,
        resizable: true,
        width: 190,
        minWidth: 180,
    },
];

export { columnDef };
